import { Filter, Report, SavedFilter } from './../models/report';
import { Customer } from './../models/customer';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { Token } from '../models/token';
import { environment } from '../../environments/environment';


@Injectable()
export class CustomerService {

  constructor(private api: ApiService) { }

  // Helper method to convert any absolute URL to relative URL for proxy and auth compatibility
  private convertToRelativeUrl(url: string): string {
    if (url && (url.startsWith('http://') || url.startsWith('https://'))) {
      try {
        const urlObj = new URL(url);
        // Return just the pathname and search, making it relative
        return urlObj.pathname + urlObj.search;
      } catch (e) {
        // If URL parsing fails, return as-is
        return url;
      }
    }
    return url;
  }

  getCustomer() {

    // Use environment variable for API base URL
    const url = environment.apiUrl + '/customer';

    return this.api.get(url).then((data)=>{
      return new Promise((resolve, reject) => {
        try
        {
          resolve(new Customer(data['ProcessOutcome']['Customer']));
        }
        catch (e)
        {
          reject(e);
        }
      })
    });
  }  

  getReportDetail(report: Report) {
    return this.api.get(this.convertToRelativeUrl(report.detailUrl)).then(data=>{
      return new Promise((resolve, reject) => {
        try
        {
          resolve(new Token(data['ProcessOutcome']['ReportDetail']));
        }
        catch (e)
        {
          reject(e);
        }
      })
    });
  }

  setLastLoginDate() {
    const url = environment.apiUrl + '/logindate';

    return this.api.post(url, {})
  }

  addReportToFavorites(report: Report) {
    this.api.post(this.convertToRelativeUrl(report.favoriteUrl), {});
  }

  removeReportToFavorites(report: Report) {
    this.api.delete(this.convertToRelativeUrl(report.favoriteUrl), {});
  }

  setReportLastViewDate(report: Report) {
    this.api.post(this.convertToRelativeUrl(report.lastViewUrl), {});
  }


  saveReportFilter(report: Report, filter: SavedFilter) {
    this.api.post(this.convertToRelativeUrl(report.filterUrl), filter);
  }

  deleteReportFilter(report: Report, filter: SavedFilter) {
    this.api.delete(this.convertToRelativeUrl(report.filterUrl), filter);
  }

  getReportFilterValueList(reportId, filter: Filter, searchText) {
    return this.api.post(this.convertToRelativeUrl(filter.filterValueListUrl), {"search": searchText}).then(data=>{
      return new Promise((resolve, reject) => {
        try
        {
          resolve(data['ProcessOutcome']['FilterValues']);
        }
        catch (e)
        {
          reject(e);
        }
      })
    });
  }
}
